<div class="basis-3xl mt-8 mb-8">

  <div class="m-y-8">
    <button class="button" (click)="togglePanel()">
      Filtri ({{ isOpen ? 'Nascondi' : 'Mostra' }})
    </button>

    <div *ngIf="isOpen" class="flex flex-col lg:flex-row gap-4 form mt-8">
      <div *ngFor="let field of searchFields" class="w-full">
        <label>{{ field.label }}</label>

        <input #inputElement *ngIf="field.type === 'text'" [(ngModel)]="inputValues[field.key]" type="text"
               (keyup)="onParamsChange(field.key, inputElement.value)"
               class="form-control" [placeholder]="'Cerca per ' + field.label.toLowerCase()">

        <select #selectElement *ngIf="field.type === 'select' && field.options" [(ngModel)]="inputValues[field.key]"
                (change)="onParamsChange(field.key, selectElement.value)"
                class="form-select">
          <option *ngIf="inputValues[field.key]===''" value="" disabled selected>-- Seleziona {{ field.label }}</option>
          <option value=""></option>
          <option *ngFor="let option of field.options" [value]="option.value">
            {{ option.label }}
          </option>

        </select>

        <input #dateElement *ngIf="field.type === 'date'" type="date" [(ngModel)]="inputValues[field.key]"
               (change)="onParamsChange(field.key, dateElement.value)" class="form-control">
      </div>
    </div>
    <div class="flex justify-end mt-4">
      <button *ngIf="isOpen" class="button" (click)="resetFilters()">
        Reimposta Filtri
      </button>

    </div>
  </div>
</div>
